<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>{{tituloCrud}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioProcedimento" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-9 col-md-9 col-sm-8 col-12">
                            <mat-label>Nome</mat-label>
                            <input matInput value="Nome" class="form-control" id="nome" required trim="blur" name="nome"
                                formControlName="nome" maxlength="60" upperCase>
                            <mat-error *ngIf="formularioProcedimento.controls.nome.hasError('required')">
                                O campo Nome é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioProcedimento.controls.nome.hasError('minlength')">
                                O campo Nome precisa conter mais do que 2 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field floatPlaceholder="always" class="form-group col-lg-3 col-md-3 col-sm-4 col-12"
                            style="padding-top: 2px;">
                            <input matInput style="display: none">
                            <mat-checkbox id="disponivel" formControlName="disponivel">Disponível</mat-checkbox>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-12 col-12">
                            <mat-label>Apelido</mat-label>
                            <input matInput value="Apelido" class="form-control" id="apelido" required trim="blur"
                                name="apelido" formControlName="apelido" maxlength="12" upperCase>
                            <mat-error *ngIf="formularioProcedimento.controls.apelido.hasError('required')">
                                O campo Apelido é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioProcedimento.controls.apelido.hasError('minlength')">
                                O campo Apelido precisa conter mais do que 2 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-6 col-12">
                            <mat-label>Tipo Agendamento</mat-label>
                            <mat-select value="Tipo Agendamento" formControlName="tipoAgendamento"
                                name="tipoAgendamento" id="tipoAgendamento" required>
                                <mat-option *ngFor="let tipoAgendamento of listaTipoAgendamento"
                                    [value]="tipoAgendamento.codigo">
                                    {{tipoAgendamento.descricao}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioProcedimento.controls.tipoAgendamento.hasError('required')">
                                O campo Tipo Agendamento é obrigatório.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-6 col-12">
                            <mat-label>Valor</mat-label>
                            <input matInput value="Valor" class="form-control" id="valor" name="valor"
                                formControlName="valor" maxlength="8" trim="blur" upperCase currencyMask
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
                            <mat-error *ngIf="formularioProcedimento.controls.valor.hasError('required')">
                                O campo Valor é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field floatPlaceholder="always" class="form-group col-lg-4 col-md-3 col-sm-3 col-6"
                            style="padding-top: 2px;">
                            <input matInput style="display: none">
                            <mat-checkbox id="dilataPupila" formControlName="dilataPupila">Dilata Pupila</mat-checkbox>
                        </mat-form-field>
                        <mat-form-field floatPlaceholder="always" class="form-group col-lg-4 col-md-3 col-sm-3 col-6"
                            style="padding-top: 2px;">
                            <input matInput style="display: none">
                            <mat-checkbox id="procedimentoConsulta" formControlName="procedimentoConsulta">É Consulta
                            </mat-checkbox>
                        </mat-form-field>
                        <mat-form-field floatPlaceholder="always" class="form-group col-lg-4 col-md-6 col-sm-6 col-12"
                            style="padding-top: 2px;">
                            <input matInput style="display: none">
                            <mat-checkbox id="executaPosDilatacao" formControlName="executaPosDilatacao">Pode realizar
                                com a pupila dilatada?</mat-checkbox>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field style="margin-top: 6.5px;"
                            class="form-group col-lg-5 col-md-5 col-sm-12 col-12">
                            <mat-label>Observação</mat-label>
                            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="8" formControlName="observacao"
                                name="observacao" id="observacao" maxlength="120" upperCase></textarea>
                        </mat-form-field>
                        <mat-form-field style="margin-top: 6.5px;"
                            class="form-group col-lg-7 col-md-7 col-sm-12 col-12">
                            <mat-label>Observação ao Selecionar</mat-label>
                            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="8" formControlName="observacaoSelecao"
                                name="observacaoSelecao" id="observacaoSelecao" maxlength="300" upperCase></textarea>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field style="margin-top: 6.5px;"
                            class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>Recomendações</mat-label>
                            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="8" formControlName="recomendacoes"
                                name="recomendacoes" id="recomendacoes" maxlength="1200" upperCase></textarea>
                        </mat-form-field>
                    </div>

                    <div class="card">
                        <div class="card-header" style="font-weight: bold;">Conflitos</div>
                        <div class="card-body" style="padding-bottom: 0px;">
                            <table class="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">Procedimento Conflito</th>
                                        <th scope="col" style="text-align: center;">Tempo (Minutos)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let procedimentoConflito of procedimento.conflitosDTO; let i = index"
                                        (click)="onClickNaTabelaDeConflito(i)"
                                        [class.active]="i == numeroDaLinhaSelecionadaNaTabelaDeConflito">
                                        <td>{{procedimentoConflito.nomeConflito}}</td>
                                        <td style="text-align: center;">{{procedimentoConflito.tempoConflito}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12" style="text-align: right;">
                                <button type="button" mat-button color="primary" matTooltip="Novo"
                                    style="margin-right: 20px;" (click)="navegarParaTelaDeCadastroDeConflito()"
                                    [disabled]="desabilitarCadastroDeConflito">
                                    Novo Conflito
                                </button>
                                <button type="button" mat-button color="warn" matTooltip="Remover"
                                    style="margin-right: 20px;"
                                    [disabled]="isInfo || numeroDaLinhaSelecionadaNaTabelaDeConflito == -1"
                                    (click)="removerConflitoSelecionado()">
                                    Remover Conflito
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10" *ngIf="!isInfo">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioProcedimento.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="voltarPaginaAnterior()"
                                matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>